<template>
  <div class="details">
    <!-- <Header></Header> -->
    <div class="detailsCenter">
      <p class="detailsCenter_p1">{{ detailsList.title }}</p>

      <p class="detailsCenter_p2" v-html="detailsList.content"></p>
    </div>
  </div>
</template>
<script>
// import Header from "./header.vue";
import { GetDetails } from "@/https/http";
export default {
  data() {
    return {
      detailsList: "",
      id: "",
    };
  },
  // components: { Header },
  created() {
    GetDetails({
      id: this.$route.params.id,
      modular: this.$route.params.modular,
    }).then((res) => {
      this.detailsList = res.result;
    });
  },
  mounted() {
    this.$EventBus.$on("NewsId", (msg) => {
      this.id = msg;
      // console.log(this.id);
    });
  },
};
</script>
<style lang="scss" scoped>
@media screen and(min-width:1020px){
  .details {
  width: 100%;
  /* height: 300px; */
  height: auto !important;
  margin-top: 100px;
  .detailsCenter {
    width: 1118px;
    margin: 0 auto;
  }
  .detailsCenter_p1 {
    /* width: 550px; */
    /* height: 25px; */
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    text-align: center;
  }
  .detailsCenter_p2 {
    width: 1104px;
    /* height: 77px; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
    margin-bottom: 100px;
  }
}
}
@media screen and(max-width:1020px){
  .details{
    width: 100%;

    .detailsCenter {
      width: 100%;
      box-sizing: border-box;
      padding-left:15px;
      padding-right:15px;
      .detailsCenter_p1{
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        text-align: center;
      }
      .detailsCenter_p2{
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        margin-bottom: 100px;
      }
    }
  }
}

</style>